// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0b1458fc","455":"fa45c349","977":"358368a0"}[chunkId] + ".chunk.js";
};